import { render, staticRenderFns } from "./cardExchange.vue?vue&type=template&id=a381768a&"
import script from "./cardExchange.vue?vue&type=script&lang=js&"
export * from "./cardExchange.vue?vue&type=script&lang=js&"
import style0 from "./cardExchange.vue?vue&type=style&index=0&id=a381768a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports